import React, { Component, Fragment } from "react";
import {
  Card,
  Icon,
  Tag,
  Radio,
  Slider,
  Checkbox,
  Row,
  Col,
  Input,
  Select,
  Tooltip,
  Collapse
} from "antd";
import F from "../../../Functions";
import WizardFooter from "./wizard-footer";
import Icon401K from "./images/new/401.svg";
import Icon403b from "./images/new/403b.svg";
import Icon457 from "./images/new/457.svg";
import IconPensionFund from "./images/new/pensionfund.svg";
import IconNo from "./images/bfile-no.svg";
import { Translate } from "react-translated";
import "../index.css";
import WizardPager from "../../../components/wizard-pager";
import SliderLayout from "./sliderlayout";

const RadioGroup = Radio.Group;
const Option = Select.Option;
const Panel = Collapse.Panel;

class Step extends Component {
  state = {
    toggle: "person"
  };
  onBusinessOwnerToggleHandler = (value) => {
    if (this.props.wizard.spouse_first_name) {
      this.props.updateField("business_owner_spouse_toggle", value);
    }
    this.props.updateField("business_owner_toggle", value);
    if (!this.props.isExternalBFile) {
      this.props.updateRadioBtnToggle();
    }
  };

  onRetirementToggleHandler = (value) => {
    if (this.props.wizard.spouse_first_name)
      this.props.updateField("asset_401k_accounts_toggle_spouse", value);
    this.props.updateField("asset_401k_accounts_toggle", value);
    if (!this.props.isExternalBFile) {
      this.props.updateRadioBtnToggle();
    }
  };
  // rangeToArray = (range) => {
  //     if (range !== "") {
  //         range = range.split('-');
  //         range[0] = parseInt(range[0].replace(/\$/g, '').replace(/,/g, ''), 10);
  //         range[1] = parseInt(range[1].replace(/\$/g, '').replace(/,/g, ''), 10);if (this.props.wizard.asset_preservation_value !== null && wizard.asset_preservation_value !== '') {
  //         for (let x in marks) {
  //             if (marks[x].val === this.props.wizard.asset_preservation_value) {
  //                 asset_preservation_value = parseInt(x, 10);
  //             }
  //         }
  //     }
  //         return range;
  //     } else {
  //         return [0, 0];
  //     }
  // }

  updateField = (name, value) => {
    this.props.updateField(name, value)
    let temp = value && value.trim() ? false : true;
    this.props.updateField('error', { ...this.props.wizard.error, [name]: temp })
  }

  updateRadioBtnToggle() {
    if (!this.props.isExternalBFile) {
      this.props.updateRadioBtnToggle();
    }
  }

  handleBlur = (name, value) => {
    if (!this.props.isExternalBFile) {
      this.props.handleBlur(name, value);
    }
  }



  render() {
    const { wizard, updateField, handleBlur, updateRadioBtnToggle } = this.props;

    let rangeValues = [
      "",
      "$1-$10,000",
      "$10,001-$25,000",
      "$25,001-$50,000",
      "$50,001-$100,000",
      "$100,001-$150,000",
      "$150,001-$200,000",
      "$200,001-$250,000",
      "$250,001-$300,000",
      "$300,001-$350,000",
      "$350,001-$400,000",
      "$400,001-$450,000",
      "$450,001-$500,000",
      "$500,001-$600,000",
      "$600,001-$700,000",
      "$700,001-$800,000",
      "$800,001-$900,000",
      "$900,001-$1,000,000"
    ];
    let v1, v2;
    for (let i = 1; i < 21; i++) {
      v2 = 1000000 + 100000 * i;
      v1 = v2 - 100000 + 1;
      rangeValues.push(F.dollar_format(v1) + "-" + F.dollar_format(v2));
    }
    rangeValues.push("$3,000,001-$4,000,000");
    rangeValues.push("$4,000,001-$5,000,000");

    // let step = 500000;
    //   for (let i = 1; i <= 18; i++) {
    //     v2 = 1000000 + step * i;
    //     v1 = v2 - step + 1;
    //     rangeValues.push(F.dollar_format(v1) + "-" + F.dollar_format(v2));
    //   }

    let marks = {};
    for (let i = 0, rangeLen = rangeValues.length; i < rangeLen; i++) {
      marks[parseInt((i / (rangeLen - 1)) * 100, 10)] = {
        label:
          i === rangeValues.length - 1 ? rangeValues[i] : i === 0 ? "$0" : "",
        val: rangeValues[i]
      };
    }

    let asset_preservation_value = 0;
    if (
      wizard.asset_preservation_value !== null &&
      wizard.asset_preservation_value !== ""
    ) {
      for (let x in marks) {
        if (marks[x].val === wizard.asset_preservation_value) {
          asset_preservation_value = parseInt(x, 10);
        }
      }
    }

    let asset_preservation_value_spouse = 0;
    if (
      wizard.asset_preservation_value_spouse !== null &&
      wizard.asset_preservation_value_spouse !== ""
    ) {
      for (let x in marks) {
        if (marks[x].val === wizard.asset_preservation_value_spouse) {
          asset_preservation_value_spouse = parseInt(x, 10);
        }
      }
    }

    let asset_401k_accounts = [];
    if (
      wizard.asset_401k_accounts !== null &&
      wizard.asset_401k_accounts !== ""
    ) {
      asset_401k_accounts = JSON.parse(wizard.asset_401k_accounts);
    }

    let asset_401k_accounts_spouse = [];
    if (
      wizard.asset_401k_accounts_spouse !== null &&
      wizard.asset_401k_accounts_spouse !== ""
    ) {
      asset_401k_accounts_spouse = JSON.parse(
        wizard.asset_401k_accounts_spouse
      );
    }
    const asset_401k_accounts_items = [
      {
        name: "401 (k)",
        icon: Icon401K,
        tip:
          "An employer sponsored retirement plan offered to employees to help save for retirement.  Money is usually payroll deducted.  The employee chooses the mutual funds within the plan to try and grow the funds for retirement."
      },
      {
        name: "403 (b)",
        icon: Icon403b,
        tip:
          "A retirement plan offered to employees or teachers in the public schools."
      },
      {
        name: "457",
        icon: Icon457,
        tip:
          "A retirement plan offered to government employees (e.g. police or firefighters)."
      },
      {
        name: "Pension Fund",
        icon: IconPensionFund,
        tip: "Pension Fund"
      }
      /*{
                name: 'None',
                icon: IconNo,
                tip: ""
            }*/
    ];

    const employees_count_list = [
      "1-5",
      "6-10",
      "11-25",
      "26-50",
      "51-100",
      "101-150",
      "150+"
    ];
    const business_list = [
      "Accounting and Financial Services",
      "Administrative Support",
      "Advertising and Marketing",
      "Architects and Engineers",
      "Bakeries",
      "Beauty Salons and Barbers",
      "Business Consultants",
      "Clothing and Accessories Stores",
      "Contractor Services",
      "Contracted Services (e.g. Locksmiths, Furniture Installers,  Commercial Cleaning, etc.)",
      "Drug Stores and Pharmacies",
      "Florists",
      "Funeral Homes",
      "Food and Beverage Stores",
      "Health Care and Medical Offices",
      "Home Goods Stores",
      "Laundry Services",
      "Legal Services",
      "Mortgage Loan Brokers",
      "Motor Vehicle Parts Dealers",
      "Personal Services (e.g. Pet Groomers)",
      "Photography",
      "Real Estate Brokers",
      "Rental Services",
      "Repair and Maintenance",
      "Self Storage",
      "Surveyors",
      "Travel Agents",
      "Veterinarians",
      "Wholesale Apparel",
      "Wholesale Drugs",
      "Wholesale Food",
      "Wholesale Hardware",
      "Wholesale Home and Office",
      "Wholesale Medical Goods",
      "Wholesale Sporting Goods",
      "Other"
    ];

    F.log("wizard ==>> Step-4 ==>> ", wizard);

    // Direct container reference to override App.js configuration
    const getCustomContainer = () => document.body;


    return (
      <Fragment>
        <div className="stepBody">
          {/* <Radio.Group onChange={(e) => {this.setState({ toggle: e.target.value });updateField('toggle',e.target.value)}} value={this.state.toggle}>
                    <Radio defaultChecked value='person'><Translate text={`Person`} /></Radio>
                    <Radio value='spouse' disabled={wizard.spouse_first_name !== '' ? false : true}><Translate text={`Spouse`} /></Radio>
                </Radio.Group>
                <br />
                <br /> */}

          <Card className="insidecard stepcard" >
            <div>
              <h5 className="headingText">
                “Are you, or your spouse/partner, self-employed, or do you have an ownership interest in a business ?” <span className='asteriskIcon'>*</span>
              </h5>
              <RadioGroup className="radiogroup"
                value={wizard.business_owner_toggle}
                onChange={(e) =>
                  this.onBusinessOwnerToggleHandler(e.target.value)
                }
              >
                <Radio value="1">
                  <Translate text={`Yes`} />
                </Radio>
                <Radio value="0">
                  <Translate text={`No`} />
                </Radio>
              </RadioGroup>
            </div>


            {wizard.business_owner_toggle === "1" ? (
              <div style={{ marginTop: 20 }}>
                <Row
                  gutter={16}
                >
                  <Col xs={24} sm={24} md={24} lg={24} xl={6} style={{ marginBottom: "16px" }}>
                    <label className='label textContent'>Business Name <span className='asteriskIcon'>*</span></label>
                    <Input className={wizard && wizard.error && wizard.error['business_name'] && 'error'}
                      value={wizard.business_name}
                      placeholder="Business Name"
                      onChange={(e) => this.updateField("business_name", e.target.value)}
                      onBlur={(e) => this.handleBlur("business_name", e.target.value)}
                      maxLength={249}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} xl={6} style={{ marginBottom: "16px" }}>
                    <label className='label textContent'>Number of Employees <span className='asteriskIcon'>*</span></label>
                    <Select className={wizard && wizard.error && wizard.error['employees_count'] && 'error'}
                      value={wizard.employees_count}
                      getPopupContainer={getCustomContainer}
                      onChange={(value) => {
                        this.updateField("employees_count", value);
                        this.updateRadioBtnToggle();
                      }
                      }

                      style={{ width: "100%" }}
                    >
                      <Option value={null} className="textContent">
                        <Translate text={`Select`} />
                        ...
                      </Option>
                      {employees_count_list.map((item, i) => (
                        <Option value={item} key={i} className="textContent">
                          {item}
                        </Option>
                      ))}
                    </Select>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} xl={6} style={{ marginBottom: "16px" }}>
                    <label className='label'>Type of Business <span className='asteriskIcon'>*</span></label>
                    <Select className={wizard && wizard.error && wizard.error['business_type'] && 'error'}
                      value={wizard.business_type}
                      getPopupContainer={getCustomContainer}
                      onChange={(value) => {
                        this.updateField("business_type", value);
                        this.updateRadioBtnToggle();
                      }}
                      style={{ width: "100%" }}
                    >
                      <Option value={""} className="textContent">
                        <Translate text={`Business Type`} />
                      </Option>
                      {business_list.map((item, i) => (
                        <Option value={item} key={i} className="textContent">
                          <Translate text={item} />
                        </Option>
                      ))}
                    </Select>
                  </Col>
                  {wizard.business_type === "Other" ? (<Col className=""
                    xs={24} sm={24} md={24} lg={24} xl={6} style={{ marginBottom: "16px" }}>
                    <label className='label'>Other Business Type <span className='asteriskIcon'>*</span></label>
                    <Input className={wizard && wizard.error && wizard.error['business_type_other'] && 'error'}
                      value={wizard.business_type_other}
                      onChange={(e) =>
                        this.updateField("business_type_other", e.target.value)
                      }
                      onBlur={(e) => {
                        this.handleBlur("business_type_other", e.target.value);
                      }}
                      maxLength={249}
                    />

                  </Col>) : null}
                </Row>
                {wizard.spouse_first_name && (
                  <Collapse defaultActiveKey={["1"]} style={{ marginTop: 20 }}>
                    <Panel header={<Translate text={"Click to add spouse/partner info"} />}>
                      <div>
                        <h4 className="titleTextUnderline headingText">
                          Add Spouse/Partner (Business Details)
                        </h4>
                        <Row
                          gutter={16}
                        >
                          <Col xs={24} sm={24} md={24} lg={24} xl={6}
                            style={{ marginBottom: "16px", marginRight: "30px" }}
                          >
                            <label  style={{ whiteSpace: 'nowrap' }} className='label textContent'>Spouse/Partner Business Name</label>
                            <Input
                              value={wizard.business_name_spouse}
                              onChange={(e) => updateField("business_name_spouse", e.target.value)}
                              onBlur={(e) => {
                                if (!this.props.isExternalBFile) {
                                  handleBlur("business_name_spouse", e.target.value)
                                }
                              }
                              }
                              maxLength={249}
                            />
                          </Col>
                          <Col xs={24} sm={24} md={24} lg={24} xl={6}
                            style={{ marginBottom: "16px" }}
                          >
                            <label className='label textContent'>Number of Employees</label>
                            <Select
                              value={wizard.employees_count_spouse}
                              getPopupContainer={getCustomContainer}
                              onChange={(value) => {
                                updateField("employees_count_spouse", value);
                                if (!this.props.isExternalBFile) {
                                  updateRadioBtnToggle();
                                }
                              }}

                              style={{ width: "100%" }}
                            >
                              <Option value={null} className="textContent">
                                <Translate text={`Select`} />
                                ...
                              </Option>
                              {employees_count_list.map((item, i) => (
                                <Option value={item} key={i} className="textContent">
                                  {item}
                                </Option>
                              ))}
                            </Select>
                          </Col>
                          <Col xs={24} sm={24} md={24} lg={24} xl={6}
                            style={{ marginBottom: "16px" }}
                          >
                            <label className='label textContent'>Type of Business</label>
                            <Select
                              value={wizard.business_type_spouse}
                              getPopupContainer={getCustomContainer}
                              onChange={(value) => {
                                updateField("business_type_spouse", value);
                                if (!this.props.isExternalBFile) {
                                  updateRadioBtnToggle();
                                }
                              }}
                              style={{ width: "100%" }}
                            >
                              <Option value={""} className="textContent">
                                <Translate text={`Business Type`} />
                              </Option>
                              {business_list.map((item, i) => (
                                <Option value={item} key={i} className="textContent">
                                  <Translate text={item} />
                                </Option>
                              ))}
                            </Select>
                          </Col>
                          {wizard.business_type_spouse === "Other" ? (<Col
                            xs={24} sm={24} md={24} lg={24} xl={6} >
                            <label className='label textContent'>Other Business Type</label>
                            <Input
                              value={wizard.business_type_other_spouse}
                              onChange={(e) =>
                                updateField("business_type_other_spouse", e.target.value)
                              }
                              onBlur={(e) => {
                                if (!this.props.isExternalBFile) {
                                  handleBlur("business_type_other_spouse", e.target.value);
                                }
                              }
                              }
                              maxLength={249}
                            />

                          </Col>) : null}
                        </Row>
                      </div>
                    </Panel>
                  </Collapse>
                )}

                <div style={{ marginTop: 20 }}>
                  <h4 className="titleTextUnderline headingText">
                    Retirement Plan
                  </h4>
                  <div>
                    <h5 className="headingText">
                      “Do you, or your spouse/partner, have a retirement plan ?” <span className='asteriskIcon'>*</span>
                    </h5>
                    <RadioGroup className="radiogroup"
                      value={wizard.asset_401k_accounts_toggle}
                      onChange={(e) =>
                        this.onRetirementToggleHandler(e.target.value)
                      }
                    >
                      <Radio value={1}>
                        <Translate text={`Yes`} />
                      </Radio>
                      <Radio value={0}>
                        <Translate text={`No`} />
                      </Radio>
                    </RadioGroup>
                  </div>

                </div>



                {wizard.asset_401k_accounts_toggle ? (
                  <div style={{ marginTop: 20 }}>
                    <h5 className="titleText2 headingText">Please Select Checklist : <span className='asteriskIcon'>*</span></h5>
                    <Checkbox.Group
                      className=""
                      value={asset_401k_accounts}
                      style={{ width: "100%" }}
                      onChange={(checkedList) => {
                        if (
                          checkedList.indexOf("None") >= 0 &&
                          asset_401k_accounts.indexOf("None") < 0
                        ) {
                          checkedList = ["None"];
                          updateField("asset_preservation_value", "");
                        }
                        if (
                          checkedList.indexOf("None") >= 0 &&
                          asset_401k_accounts.indexOf("None") >= 0 &&
                          checkedList.length > 1
                        ) {
                          const i = checkedList.indexOf("None");
                          checkedList.splice(i, 1);
                        }
                        if (checkedList.length === 0) {
                          updateField("asset_preservation_value", ""); // new add
                        }
                        updateField(
                          "asset_401k_accounts",
                          JSON.stringify(checkedList)
                        );
                        if (!this.props.isExternalBFile) {
                          updateRadioBtnToggle();
                        }
                      }}


                    >
                      <Row gutter={[32, 32]} style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {asset_401k_accounts_items.map((item, i) => {
                          return (
                            <Col key={i}
                              xs={24}
                              sm={12}
                              md={8}
                              lg={6} className="checkbox_layout">
                              {item.tip !== "" ? (
                                <Tooltip placement="bottom" title={item.tip} getPopupContainer={getCustomContainer}>
                                  <Checkbox value={item.name} style={{ width: "100%" }}>
                                    <div className="checkbox_items"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                      }}
                                    >
                                      <div className="icon"
                                        style={{ flexShrink: 0 }}
                                      >
                                        <img
                                          style={{
                                            objectFit: "contain",
                                          }}
                                          src={item.icon}
                                          alt={item.name}
                                        />
                                      </div>
                                      <div className="title" style={{ flexGrow: 1 }}>
                                        <Translate text={item.name} />
                                      </div>
                                    </div>
                                  </Checkbox>
                                </Tooltip>
                              ) : (
                                <Checkbox value={item.name}>
                                  <div className="checkbox_items">
                                    <div className="icon">
                                      <img src={item.icon} alt={item.name} />
                                    </div>
                                    <div className="title">
                                      <Translate text={item.name} />
                                    </div>
                                  </div>
                                </Checkbox>
                              )}
                            </Col>
                          );
                        })}
                      </Row>
                    </Checkbox.Group>

                    {asset_401k_accounts.length > 0 &&
                      asset_401k_accounts.indexOf("None") < 0 ? (
                      <div style={{ marginTop: 20 }}>
                        <h5 className="headingText">“What is the approximate value of the retirement plan?” <span className='asteriskIcon'>*</span></h5>
                        <div
                          style={{
                            width: "100%",
                            maxWidth: window.innerWidth > 768 ? "100%" : "400px",
                            margin: "0 auto",
                            padding: "10px",
                          }}
                        >
                          <div
                            style={{
                              width: "100%",
                              maxWidth: window.innerWidth > 768 ? "100%" : "400px",
                              margin: "0 auto",
                              padding: "10px",
                            }}
                          >
                            <SliderLayout
                              marks={marks}
                              value={asset_preservation_value}
                              updateField={updateField}
                              updateRadioBtnToggle={updateRadioBtnToggle}
                              name="asset_preservation_value"
                            />
                          </div>
                        </div>
                        <div className="sliderValue center-align silder-align silder-align"

                        >
                          {wizard.asset_preservation_value || "$0"}
                        </div>
                      </div>
                    ) : null}
                    {wizard.spouse_first_name && (

                      <Collapse defaultActiveKey={["1"]} style={{ marginTop: 20 }}>
                        <Panel header={<Translate text={"Click to add spouse/partner info"} />}>
                          <div>
                            <h4 className="titleTextUnderline headingText">Spouse/Partner Retirement Details</h4>
                            {/* <h2>
                              <Translate text={`Spouse Retirement Details`} />
                            </h2> */}
                            <h5 className="titleText2 headingText">Please Select Checklist : </h5>
                            <Checkbox.Group
                              className=""
                              value={asset_401k_accounts_spouse}
                              style={{ width: "100%" }}
                              onChange={(checkedList) => {
                                if (
                                  checkedList.indexOf("None") >= 0 &&
                                  asset_401k_accounts_spouse.indexOf("None") <
                                  0
                                ) {
                                  checkedList = ["None"];
                                  updateField(
                                    "asset_preservation_value_spouse",
                                    ""
                                  );
                                }
                                if (
                                  checkedList.indexOf("None") >= 0 &&
                                  asset_401k_accounts_spouse.indexOf(
                                    "None"
                                  ) >= 0 &&
                                  checkedList.length > 1
                                ) {
                                  const i = checkedList.indexOf("None");
                                  checkedList.splice(i, 1);
                                }
                                if (checkedList.length === 0) {
                                  updateField(
                                    "asset_preservation_value_spouse",
                                    ""
                                  ); // new add
                                }
                                updateField(
                                  "asset_401k_accounts_spouse",
                                  JSON.stringify(checkedList)
                                );
                                if (!this.props.isExternalBFile) {
                                  updateRadioBtnToggle();
                                }
                              }}


                            >
                              <Row gutter={[16, 16]} style={{ display: 'flex', flexWrap: 'wrap' }}>
                                {asset_401k_accounts_items.map((item, i) => {
                                  return (
                                    <Col key={i}
                                      xs={24}
                                      sm={12}
                                      md={8}
                                      lg={6} className="checkbox_layout">
                                      {item.tip !== "" ? (
                                        <Tooltip
                                          placement="bottom"
                                          title={item.tip}
                                          getPopupContainer={getCustomContainer}
                                        >
                                          <Checkbox value={item.name} style={{ width: "100%" }}>
                                            <div className="checkbox_items"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "10px",
                                              }}>
                                              <div className="icon"
                                                style={{ flexShrink: 0 }}
                                              >
                                                <img
                                                  src={item.icon}
                                                  alt={item.name}
                                                  style={{
                                                    objectFit: "contain",
                                                  }}
                                                />
                                              </div>
                                              <div className="title" style={{ flexGrow: 1 }}>
                                                <Translate text={item.name} />
                                              </div>
                                            </div>
                                          </Checkbox>
                                        </Tooltip>
                                      ) : (
                                        <Checkbox value={item.name} style={{ width: "100%" }}>
                                          <div className="checkbox_items"
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "10px",
                                            }}
                                          >
                                            <div className="icon"
                                              style={{ flexShrink: 0 }}
                                            >
                                              <img
                                                src={item.icon}
                                                alt={item.name}
                                                style={{
                                                  objectFit: "contain",
                                                }}
                                              />
                                            </div>
                                            <div className="title" style={{ flexGrow: 1 }}>
                                              <Translate text={item.name}
                                              />
                                            </div>
                                          </div>
                                        </Checkbox>
                                      )}
                                    </Col>
                                  );
                                })}
                              </Row>
                            </Checkbox.Group>

                            {asset_401k_accounts_spouse.length > 0 &&
                              asset_401k_accounts_spouse.indexOf("None") < 0 ? (
                              <div style={{ marginTop: 20 }} >
                                <h5 className="headingText">“What is the approximate value of the retirement plan?” </h5>
                                <SliderLayout
                                  marks={marks}
                                  value={asset_preservation_value_spouse}
                                  updateField={updateField}
                                  updateRadioBtnToggle={updateRadioBtnToggle}
                                  name="asset_preservation_value_spouse"
                                />
                                <div className="sliderValue center-align slider-align">
                                  {wizard.asset_preservation_value_spouse ||
                                    "$0"}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </Panel>
                      </Collapse>

                    )}
                  </div>
                ) : null}

              </div>
            ) : null}
            <Row style={{ display: 'flex', justifyContent: 'center' }} className='center'>
              <Col span={18} className='didyouKnowSection'>
                {/* <img src={require("./images/didyouKnow.png")} width={120} className='imgdid' /> */}
                <img src={require('./images/didYouKnowBulb.jpg')} width={40} alt='' />
                <h4>Did You Know</h4>
                {/* <p className="textContent">“If your customer is a business owner, it may be good time to have a commercial policy conversation. Also, the business assets associated with the insured could be exposed in a liability suit.”</p> */}
                <p className="textContent">“If you are a business owner, it may be good time to have a commercial policy conversation. Your business assets could be exposed in a liability suit.”</p>
              </Col>
            </Row>
            {/* <WizardFooter {...this.props} /> */}
          </Card>
        </div>
        <div className='stepFooter'>
          <WizardFooter {...this.props} />
        </div>
      </Fragment>
    );
  }
}

export default Step;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/step4_updated.js